import React from 'react';

import {PANELMANAGER_SET_PANEL_TOOLTIP} from '../../constants';

export type SetPanelTooltipAction = {
    type : typeof PANELMANAGER_SET_PANEL_TOOLTIP;
    panelKey : string;
    tooltip : React.ReactNode;
}

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {React.ReactNode} tooltip
 *
 * @return {SetPanelTooltipAction}
 */
const setPanelTooltip = ( panelKey : string, tooltip : React.ReactNode ) : SetPanelTooltipAction => {
    return {
        type: PANELMANAGER_SET_PANEL_TOOLTIP,
        panelKey,
        tooltip
    };
}
export type SetPanelTooltip = typeof setPanelTooltip;

export default setPanelTooltip;
